import { UserVerificationStatus } from '../../../constants/userVerificationStatus';
import VerificationStatusPending from 'assets/svgIcons/VerificationStatusPending';
import VerificationStatusRejected from 'assets/svgIcons/VerificationStatusRejected';

export const STATUS_MAPPING = {
  [UserVerificationStatus.POSTED]: {
    text: 'Verification awaiting approval',
    icon: VerificationStatusPending,
  },
  [UserVerificationStatus.REJECTED]: {
    text: 'Verification failed',
    icon: VerificationStatusRejected,
  },
};
